import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AppointmentDetails } from "tutorapp-components";
import { apiService } from "../utils/apiRequest";
import { CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";


const EditAppointment = () => {

   const userPreferences = useSelector((state) => state.userPreferences);

  const [loading, setLoading] = useState(false);
  const [appointmentData , setAppointmentData] = useState(null)
  const [studentNames, setStudentNames] = useState([]);
  
  const navigate = useNavigate();
 const { state } = useLocation();
  const appointmentId = state?.appointment_id;
  
  // const userPreferences
  const editIcons = {
    general: "./images/ic_edit.svg",
    dateTime: "./images/ic_edit.svg",
    settings: "./images/ic_edit.svg",
    appointmentFor: "./images/ic_appointment.svg",
    subject: "./images/ic_subject.svg",
    enrollment: "./images/ic_enrollment.svg",
    students: "./images/ic_student.svg",
    remainingHours: "./images/ic_time.svg",
    date: "./images/ic_calendar.svg",
    time: "./images/ic_time.svg",
    sessionsPerWeek: "./images/ic_sessions_per_week.svg",
    sessionType: "./images/ic_online.svg",
    repeat: "./images/ic_repeat.svg",
    tutoringAddress: "./images/ic_tutoring_address.svg",
    backarrow: "./images/ic_back.svg",
    delete: "./images/ic_delete.svg",
  };

  const handleEditGeneral = () => {};  
  const handleDateTime = () => {};
  const handleSetting = () => {};
  const onArrowClick = () => navigate("/Myappointment");
  const onDelete = () => console.log("Delete clicked");
 
  //for fetching appointmentdetails
  useEffect(() => {
    const fetchAppointmentDetails = async () => {
      if (!appointmentId) {
        console.error("appointmentId is missing");
        return;
      }

      try {
        setLoading(true);
        const getAppointmentDetails = process.env.REACT_APP_API_URL + "getAppointmentDetails";
        const options = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ appointment_id: appointmentId }),
        };

        const response = await apiService(getAppointmentDetails, options);

        if (response.status === "success") {
          setAppointmentData(response.data);
        } else {
          console.error("Failed to fetch appointment details:", response.message);
        }
      } catch (error) {
        console.error("Error fetching appointment details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAppointmentDetails()

  }, [appointmentId]);

  const getStudentNames = async (studentIds) => {
      setLoading(true); // Start loading
      try {
        const endpoint = process.env.REACT_APP_API_URL + 'getStudentName';
        const options = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ student_ids: studentIds }),
        };
  
        const response = await apiService(endpoint, options);
  
        if (response.status === 'success') {
          setStudentNames(response.data.valid_students);
       
  
        } else {
          toast.error(response.message || "Failed to fetch student names", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "dark",
            style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" }
          });
        }
      } catch (error) {
        console.error("Error fetching student names:", error);
        toast.error("An error occurred while fetching student names", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
          style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" }
        });
      } finally {
        setLoading(false); // Stop loading
      }
    };


    useEffect(() => {
  if (appointmentData?.students?.length > 0) {
    getStudentNames(appointmentData.students);
  }
}, [appointmentData]);


    if ( loading ) {
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <CircularProgress style={{ color: "black" }} />
        </div>
      );
    }  

  return (
    <AppointmentDetails
      appointmentdata={appointmentData}
      userPreferences={userPreferences}
      icons={editIcons}
      handleSetting={handleSetting}
      handleDateTime={handleDateTime}
      handleEditGeneral={handleEditGeneral}
      ondelete={onDelete}
      onarrowclick={onArrowClick}
      studentlist={studentNames}
    />
  );
};

export default EditAppointment;
